"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrmDealsheetSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const meta_data_1 = require("../base/meta-data");
exports.CrmDealsheetSchema = {
    name: 'crm-dealsheet',
    alias: 'CRM Deal Sheet',
    shortName: 'Deal Sheet',
    applications: ['aap'],
    // crm-service creates this index with its own mapping and writes every document itself. The
    // search-sync migration would replace that mapping with one derived from this schema, which
    // breaks the service's org filter and substring matching.
    disabled: true,
    returnType: {
        aap: transport_types_1.Crm.Dealsheet,
    },
    searchableAttributes: [
        {
            field: 'name',
            alias: 'Deal Sheet Name',
            shortName: 'Name',
            searchableByDefault: true,
        },
        {
            field: 'dealsheetNumber',
            alias: 'Deal Sheet Number',
            shortName: 'Number',
            searchableByDefault: true,
        },
        {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- an array of numbers, which the field type cannot name
            field: 'proposalNumbers',
            alias: 'Proposal Number',
            shortName: 'Proposal #',
            searchableByDefault: true,
        },
    ],
    filterableAttributes: [
        {
            field: 'status',
            alias: 'Deal Sheet Status',
            shortName: 'Status',
            type: 'STRING',
            allowedOperators: 'ALL',
            options: [
                { value: 'IN_PROGRESS', label: 'In Progress' },
                { value: 'NEEDS_REVIEW', label: 'Needs Review' },
                { value: 'CLOSED', label: 'Closed' },
            ],
            allowsMultipleValues: true,
        },
        {
            field: 'contractEndDate',
            alias: 'Contract End Date',
            shortName: 'Due',
            type: 'DATE',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
        },
        ...meta_data_1.MetaDataFilters,
    ],
    extraMappings: [],
};
//# sourceMappingURL=crm-dealsheet.js.map